import {
  CalendarContext,
  CommonContext,
  EmployeeApi,
  HolidayBooking,
  theme,
  useHoliday,
} from '@abdoo/common';
import { Box, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import Select from 'react-select';

import { BookingItem } from './BookingItem';

export const BookingList = () => {
  const { refreshCalendarSummary, refreshHolidayBookings } = useContext(CalendarContext);
  const { isOnline } = useContext(CommonContext);
  const offlineColor = theme.palette.offline.main;
  const [holidays, setHolidays] = useState([] as HolidayBooking[]);

  const approvalStatusesOptions = [
    { value: 0, label: 'None' },
    { value: 1, label: 'Pending' },
    { value: 2, label: 'Approved' },
    { value: 3, label: 'Rejected' },
    { value: 4, label: 'Cancelled' },
    { value: 5, label: 'Pending cancellation' },
    { value: 6, label: 'Withdrawn' },
  ];
  const bookingTimeStatusOptions = [
    { value: 1, label: 'Previous' },
    { value: 2, label: 'Upcoming' },
    { value: 3, label: 'All' },
  ];

  const emptyBookings = [
    new HolidayBooking(),
    new HolidayBooking(),
    new HolidayBooking(),
  ];
  const [approvalStatuses, setApprovalStatuses] = useState<number[]>(
    approvalStatusesOptions.map((e) => e.value),
  );

  const [radioStatus, setRadioStatus] = useState<number>(
    bookingTimeStatusOptions[1].value,
  );
  const { holidaysFiltered } = useHoliday(EmployeeApi);

  const get = useCallback(
    async (newApprovalStatuses: number[], newRadioStatus: number) => {
      holidaysFiltered().mutation(newApprovalStatuses, newRadioStatus, setHolidays);
    },
    // Turning this on causes us to fly into an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const updateHoliday = useCallback(() => {
    refreshCalendarSummary();
    refreshHolidayBookings();
    get(approvalStatuses, radioStatus);
  }, [
    refreshCalendarSummary,
    refreshHolidayBookings,
    get,
    approvalStatuses,
    radioStatus,
  ]);

  useEffect(() => {
    get(approvalStatuses, radioStatus);
  }, [approvalStatuses, get, radioStatus]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateSelectedApprovalStatuses = useCallback((options: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setApprovalStatuses(options.map((e: any) => e.value));
  }, []);

  const updateSelectedTimeStatus = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setRadioStatus(parseInt(event.target.value, 10));
    },
    [],
  );
  const holidaysToShow = holidaysFiltered().isLoading ? emptyBookings : holidays;

  return (
    <>
      <Box sx={{ paddingLeft: '1em', paddingRight: '1em' }}>
        <Grid container justifyContent={'center'}>
          <Grid item xs={12} md={6}>
            <p style={{ color: !isOnline ? offlineColor : '' }}>Select statuses</p>
            <Select
              options={approvalStatusesOptions}
              onChange={updateSelectedApprovalStatuses}
              isMulti={true}
              isDisabled={!isOnline}
            />
            <RadioGroup value={radioStatus} row onChange={updateSelectedTimeStatus}>
              {bookingTimeStatusOptions.map((status, index) => (
                <FormControlLabel
                  key={index}
                  value={status.value}
                  control={<Radio />}
                  label={status.label}
                  disabled={!isOnline}
                />
              ))}
            </RadioGroup>
          </Grid>
          {holidaysToShow.length > 0 ? (
            holidaysToShow.map((holiday, index) => (
              <Grid container item key={index} xs={12} md={12} justifyContent={'center'}>
                <Grid key={index} item xs={12} md={6}>
                  <BookingItem
                    key={index}
                    holiday={holiday}
                    updateHoliday={updateHoliday}
                    isLoading={holidaysFiltered().isLoading}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid container item xs={12} md={12} justifyContent={'center'}>
              <Grid item xs={12} md={6}>
                <Box>
                  <p>Filter did not find any records</p>
                </Box>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};
